(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dstrct-product-links"] && !Shopify.designMode) return;
  try {
    if (!window.dstrctProductDialogsBound) {
    window.dstrctProductDialogsBound = true;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-dstrct-dialog-open]');
      if (openButton) {
        const dialog = document.getElementById(openButton.dataset.dstrctDialogOpen);
        if (dialog && !dialog.open) {
          dialog.dstrctOpener = openButton;
          dialog.showModal();
        }
        return;
      }

      const closeButton = event.target.closest('[data-dstrct-dialog-close]');
      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      if (event.target.matches('.dstrct-product-dialog')) {
        event.target.close();
      }
    });

    document.addEventListener(
      'close',
      (event) => {
        if (event.target.matches('.dstrct-product-dialog') && event.target.dstrctOpener) {
          event.target.dstrctOpener.focus();
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
